<div class="form-container" [formGroup]="form" *ngIf="translations">
  <div [formArrayName]="'units'">
    <div
      *ngFor="let unit of units.controls; index as i"
      [formGroupName]="i"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
      [@addRemoveAnimation]>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 inner-unit-container">
        <app-review-section
          #unitSection
          [title]="translations.unitHeader + ' ' + (i + 1)"
          [applicationId]="applicationId"
          [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_Unit"
          [entityId]="unit.value.id"
          [deletable]="units?.value.length > 1"
          (delete)="removeUnit(i)"
          [isDetailsView]="isDetailsView"
          [hasBorders]="true">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controlsService.unitControls.unavailable.visible">
              <app-checkbox
                [label]="controlsService.unitControls.unavailable.label()"
                [formControl]="unit.controls.unavailable"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.deviceName.visible">
              <app-input
                [label]="'drr-ccd-devices.device-name-lbl' | translate"
                [formControl]="unit.controls.registrationUnit.get('deviceName')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.mainsInterferenceDeviceType.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.mains-interference-device-type-lbl' | translate"
                [options]="mainsInterferenceDeviceOptions"
                [formControl]="unit.controls.registrationUnit.get('mainsInterferenceDeviceType')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.connectionType.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.connection-type-lbl' | translate"
                [options]="connectionTypeOptions"
                [formControl]="unit.controls.registrationUnit.get('connectionType')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.heatingType.visible">
              <app-input
                [label]="'drr-ccd-devices.heating-type-lbl' | translate"
                [formControl]="unit.controls.registrationUnit.get('heatingType')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
            </div>

            <!-- single-device-type -->
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.singleDeviceType.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.single-device-type-lbl' | translate"
                [options]="singleDeviceTypeOptions"
                [formControl]="unit.controls.registrationUnit.get('singleDeviceType')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controlsService.unitControls.manufacturer.visible">
              <app-input
                [label]="'drr-ccd-devices.manufacturer-of-device-lbl' | translate"
                [formControl]="unit.controls.manufacturer"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controlsService.unitControls.designationType.visible">
              <app-input
                [label]="'drr-ccd-devices.type-designation-lbl' | translate"
                [formControl]="unit.controls.designationType"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controlsService.unitControls.electricalPower.visible">
              <app-input-number
                [label]="'drr-ccd-devices.electrical-power-lbl' | translate"
                [formControl]="unit.controls.electricalPower"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                <app-suffix>
                  <span class="unit-margin">{{ 'drr-ccd-devices.power-units' | translate }}</span>
                </app-suffix>
              </app-input-number>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.deviceNumber.visible">
              <app-input
                [label]="'drr-ccd-devices.device-number-lbl' | translate"
                [formControl]="unit.controls.registrationUnit.get('deviceNumber')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
            </div>

            <!-- upload-data-sheet -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadUnitDataSheet">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-sheet' | translate"
                [data]="unit.controls.dataSheetRawValue?.value"
                documentType="drr_ccd_data_sheet"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadUnitDataSheet || (!unitSection.isDataEditable && !isUnitEditable)"
                (formInited)="fileFormInited($event, unit, 'dataSheet')"
                [clearOn]="fileClearStream(unit)"></app-file-input-form-control>
            </div>

            <!-- upload-circuit-diagram-document -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadCircuitDiagram">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-circuit-diagram' | translate"
                [data]="unit.controls.circuitDiagramRawValue?.value"
                documentType="drr_ccd_circuit_diagram"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadCircuitDiagram || (!unitSection.isDataEditable && !isUnitEditable)"
                (formInited)="fileFormInited($event, unit, 'circuitDiagramDocument')"
                [clearOn]="fileClearStream(unit)"></app-file-input-form-control>
            </div>
          </div>

          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.hasAdditionalHeating.visible">
              <app-radio-button-yes-no
                [name]="'hasAdditionalHeating_' + deviceIndex + '_' + i"
                [label]="'drr-ccd-devices.additional-heating-lbl' | translate"
                [formControl]="unit.controls.hasAdditionalHeating"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"
                [style]="'horizontal'"></app-radio-button-yes-no>
            </div>

            <!-- loadManagementAvailable -->
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.loadManagementAvailable.visible">
              <app-radio-button-yes-no
                [name]="'loadManagementAvailable_' + deviceIndex + '_' + i"
                [label]="'drr-ccd-devices.load-management-available' | translate"
                [formControl]="unit.controls.loadManagementAvailable"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"
                [style]="'horizontal'"></app-radio-button-yes-no>
            </div>

            <!-- loadManagementType -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showLoadManagementType(i)">
              <app-drop-down
                [label]="'drr-ccd-devices.information-about-load-management-lbl' | translate"
                [options]="loadManagementTypeOptions"
                [formControl]="unit.controls.loadManagementType"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <!-- couplingType -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controlsService.unitControls.couplingType.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.coupling-type-lbl' | translate"
                [options]="couplingTypeOptions"
                [formControl]="unit.controls.couplingType"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showAdditionalHeaterField(i)">
              <app-input-number
                [label]="'drr-ccd-devices.power-of-additional-heater-lbl' | translate"
                [formControl]="unit.controls.powerOfAdditionalHeater"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                <app-suffix>
                  <span class="unit-margin">{{ 'drr-ccd-devices.power-units' | translate }}</span>
                </app-suffix>
              </app-input-number>
            </div>

            <!-- upload-data-sheet-WR -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadDataSheetWr(i)">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-sheet-wr-lbl' | translate"
                [data]="unit.controls.dataSheetRwRawValue?.value"
                documentType="drr_ccd_data_sheet_wr"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadDataSheetWr(i) || (!unitSection.isDataEditable && !isUnitEditable)"
                [clearOn]="fileClearStream(unit)"
                (formInited)="fileFormInited($event, unit, 'dataSheetWr')"></app-file-input-form-control>
            </div>

            <!-- measuring-concept -->
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.skMeasuringConcept.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.measuring-concept-lbl' | translate"
                [options]="measuringConceptOptions"
                [formControl]="unit.controls.registrationUnit.get('skMeasuringConcept')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
            </div>

            <!-- upload-data-collection-document -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadDataCollection">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-collection' | translate"
                [data]="unit.controls.registrationUnit.get('dataCollectionRawValue')?.value"
                documentType="drr_ccd_data_collection"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadDataCollection || (!unitSection.isDataEditable && !isUnitEditable)"
                (formInited)="fileFormInited($event, unit.controls.registrationUnit, 'dataCollectionDocument')"
                [clearOn]="fileClearStream(unit)"></app-file-input-form-control>
            </div>

            <!-- upload-site-plan-installation-document -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadSitePlanInstallation">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-site-plan-installation' | translate"
                [data]="unit.controls.registrationUnit.get('sitePlanInstallationRawValue')?.value"
                documentType="drr_ccd_site_plan_installation"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadSitePlanInstallation || (!unitSection.isDataEditable && !isUnitEditable)"
                (formInited)="fileFormInited($event, unit.controls.registrationUnit, 'sitePlanInstallationDocument')"
                [clearOn]="fileClearStream(unit)"></app-file-input-form-control>
            </div>

            <!-- storage not in parallel mode -->
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.storageNotInParallelMode.visible">
              <app-checkbox
                [label]="'drr-ccd-devices.storage-in-parallel-mode' | translate"
                [formControl]="unit.controls.storageNotInParallelMode"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>
            <app-note [header]="" *ngIf="controlsService.unitControls.storageNotInParallelMode.visible">
              <span [innerHTML]="'drr-ccd-devices.parallel-grid-operation-note' | translate"></span>
            </app-note>
          </div>

          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-container mt-1">
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isSystemInstallationVdeArn4100.visible">
              <app-checkbox
                [label]="'drr-ccd-devices.system-installation-vde-arn4100' | translate"
                [formControl]="unit.controls.registrationUnit.get('isSystemInstallationVdeArn4100')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isPowerProvidedFromCustomerSystem.visible">
              <app-checkbox
                [label]="'drr-ccd-devices.power-from-customer-system' | translate"
                [formControl]="unit.controls.registrationUnit.get('isPowerProvidedFromCustomerSystem')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isEmergencyGeneratorNotInParallel.visible">
              <app-checkbox
                [label]="'drr-ccd-devices.emergency-generator-not-in-parallel' | translate"
                [formControl]="unit.controls.registrationUnit.get('isEmergencyGeneratorNotInParallel')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isEnergyFromEmergencyGeneratorNotRemunerated.visible">
              <app-checkbox
                [label]="'drr-ccd-devices.emergency-generator-not-remunerated' | translate"
                [formControl]="unit.controls.registrationUnit.get('isEnergyFromEmergencyGeneratorNotRemunerated')"
                [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
            </div>
            <app-note
              [header]=""
              *ngIf="controlsService.unitControls.registrationUnit.controls.isEnergyFromEmergencyGeneratorNotRemunerated.visible">
              <span [innerHTML]="'drr-ccd-devices.generating-plant-registration-note' | translate"></span>
            </app-note>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6"
                *ngIf="controlsService.unitControls.registrationUnit.controls.isNetworkDisturbanceCompliedWithVdeArn4100.visible">
                <app-radio-button-yes-no
                  [name]="'isNetworkDisturbanceCompliedWithVdeArn4100_' + deviceIndex + '_' + i"
                  [label]="'drr-ccd-devices.network-disturbance-compiled' | translate"
                  [formControl]="unit.controls.registrationUnit.controls.isNetworkDisturbanceCompliedWithVdeArn4100"
                  [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"
                  [style]="'horizontal'"></app-radio-button-yes-no>
              </div>
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6"
                *ngIf="controlsService.unitControls.registrationUnit.controls.isInputOfCustomerSystemLessOrEqual75.visible">
                <app-radio-button-yes-no
                  [name]="'isInputOfCustomerSystemLessOrEqual75' + deviceIndex + '_' + i"
                  [label]="'drr-ccd-devices.input-of-customer-system75' | translate"
                  [formControl]="unit.controls.registrationUnit.controls.isInputOfCustomerSystemLessOrEqual75"
                  [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"
                  [style]="'horizontal'"></app-radio-button-yes-no>
              </div>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 p-1"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isNetworkDisturbanceCompliedWithVdeArn4100.visible">
              {{ 'drr-ccd-devices.network-disturbances-title' | translate }}
              <hr />
            </div>

            <!-- network-disturbances-data-fields -->
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
              *ngIf="controlsService.unitControls.registrationUnit.controls.isNetworkDisturbanceCompliedWithVdeArn4100.visible">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.isAsynchronousMotor.visible">
                  <app-checkbox
                    [label]="'drr-ccd-devices.asynchronous-motor' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('isAsynchronousMotor')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.ratedPower.visible">
                  <app-input-number
                    [label]="
                      controlsService.networkDisturbancesDataControls.ratedPower.label(
                        unit.controls.registrationUnit.get('mainsInterferenceDeviceType')?.value
                      )
                    "
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('ratedPower')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>
                      {{
                        controlsService.networkDisturbancesDataControls.ratedPower.suffix(
                          unit.controls.registrationUnit.get('mainsInterferenceDeviceType')?.value
                        )
                      }}
                    </app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.ratedSpeed.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.rated-speed-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('ratedSpeed')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>1/min</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.maxWeldingPerformance.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.max-welding-performance-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('maxWeldingPerformance')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>kVA</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.powerFactor.visible">
                  <app-input
                    [label]="'drr-ccd-devices.power-factor-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('powerFactor')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.weldNumber.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.weld-number-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('weldNumber')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.per-minute' | translate }}</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.weldDuration.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.weld-duration-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('weldDuration')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.seconds' | translate }}</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.ratioStartingCurrentRated.visible">
                  <app-input
                    [label]="'drr-ccd-devices.ratio-starting-current-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('ratioStartingCurrentRated')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.startUpCircuit.visible">
                  <app-drop-down
                    [label]="'drr-ccd-devices.startup-circuit-type-lbl' | translate"
                    [options]="startupCircuitTypeOptions"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('startUpCircuit')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.otherStartupCircuit.visible">
                  <app-input
                    [label]="'drr-ccd-devices.other-startup-circuit-type-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('otherStartupCircuit')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.xrayRatedPower.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.xray-rated-power-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('xrayRatedPower')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>kVA</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.xrayRequiredPower.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.xray-required-power-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('xrayRequiredPower')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>kVA</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.powerConverterEfficiency.visible">
                  <app-input
                    [label]="'drr-ccd-devices.power-converter-efficiency-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('powerConverterEfficiency')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.maxNumberOfRecordings.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.max-number-recordings-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('maxNumberOfRecordings')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.per-hour' | translate }}</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.powerConverterType.visible">
                  <app-drop-down
                    [label]="'drr-ccd-devices.power-converter-type-lbl' | translate"
                    [options]="powerConverterTypeOptions"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('powerConverterType')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.rectifierDesign.visible">
                  <app-input
                    [label]="'drr-ccd-devices.rectifier-design-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('rectifierDesign')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.pulseNumber.visible">
                  <app-input
                    [label]="'drr-ccd-devices.pulse-number-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('pulseNumber')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.centerPointCircuitType.visible">
                  <app-drop-down
                    [label]="'drr-ccd-devices.center-point-circuit-type-lbl' | translate"
                    [options]="centerPointCircuitTypeOptions"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('centerPointCircuitType')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.maxInrushCurrent.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.max-inrush-current-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('maxInrushCurrent')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>A</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.reactivePowerRange.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.reactive-power-range-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('reactivePowerRange')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>kvar</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.reactivePowerPerStage.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.reactive-power-stage-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('reactivePowerPerStage')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>kvar</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.numberOfSteps.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.number-of-steps-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('numberOfSteps')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.resonanceFrequency.visible">
                  <app-input
                    [label]="'drr-ccd-devices.resonance-frequency-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('resonanceFrequency')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
              </div>

              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.isDriveWithPowerConverter.visible">
                  <app-checkbox
                    [label]="'drr-ccd-devices.drive-with-power-converter' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('isDriveWithPowerConverter')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-checkbox>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.ratedVoltage.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.rated-voltage-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('ratedVoltage')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>V</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.ratedCurrent.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.rated-current-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('ratedCurrent')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>A</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.efficiency.visible">
                  <app-input
                    [label]="'drr-ccd-devices.efficiency-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('efficiency')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.startUpType.visible">
                  <app-drop-down
                    [label]="'drr-ccd-devices.startup-type-lbl' | translate"
                    [options]="startupTypeOptions"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('startUpType')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-drop-down>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.loadNumberRotationChanges.visible">
                  <app-input
                    [label]="'drr-ccd-devices.load-number-rotation-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('loadNumberRotationChanges')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.per-minute' | translate }}</app-suffix>
                  </app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.attemptsPerHour.visible">
                  <app-input-number
                    [label]="'drr-ccd-devices.number-of-attempts-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('attemptsPerHour')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.per-hour' | translate }}</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.attemptsPerDay.visible">
                  <app-input-number
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('attemptsPerDay')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>{{ 'drr-ccd-devices.per-day' | translate }}</app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.commutationInductance.visible">
                  <app-input
                    [label]="'drr-ccd-devices.commutation-inductance-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('commutationInductance')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.converterTransformer.visible">
                  <app-input
                    [label]="'drr-ccd-devices.converter-transformer-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('converterTransformer')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.relativeVoltage.visible">
                  <app-input-number
                    [label]="
                      controlsService.networkDisturbancesDataControls.relativeVoltage.label(
                        unit.controls.registrationUnit.get('mainsInterferenceDeviceType')?.value
                      )
                    "
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('relativeVoltage')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable">
                    <app-suffix>
                      {{
                        controlsService.networkDisturbancesDataControls.relativeVoltage.suffix(
                          unit.controls.registrationUnit.get('mainsInterferenceDeviceType')?.value
                        )
                      }}
                    </app-suffix>
                  </app-input-number>
                </div>
                <div
                  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                  *ngIf="controlsService.networkDisturbancesDataControls.switchingGroup.visible">
                  <app-input
                    [label]="'drr-ccd-devices.switching-group-lbl' | translate"
                    [formControl]="unit.controls.registrationUnit.controls.networkDisturbancesData.get('switchingGroup')"
                    [forceDisable]="!unitSection.isDataEditable && !isUnitEditable"></app-input>
                </div>
              </div>
            </div>
            <!-- network-disturbances-data-fields -->
          </div>

          <div formArrayName="subUnits" id="sub-units-container" *ngIf="unit?.controls.subUnits">
            <div
              *ngFor="let subUnit of unit?.controls.subUnits?.controls; let ii = index"
              [formGroupName]="ii"
              [id]="'subunit-' + ii"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 nested-item-lev"
              [@addRemoveAnimation]>
              <app-review-section
                #subUnitSection
                [title]="translations.subUnitHeader + ' ' + (ii + 1)"
                [applicationId]="applicationId"
                [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_SubUnit"
                [entityId]="subUnit.value.id"
                [deletable]="unit.value.subUnits?.length > 1"
                [isDetailsView]="isDetailsView"
                (delete)="removeSubUnit(unit, ii)">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
                  <!-- outer-unit-unavailable -->
                  <div
                    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                    *ngIf="controlsService.subUnitControls.unavailable.visible && ii === 0">
                    <app-checkbox
                      [label]="controlsService.subUnitControls.unavailable.label()"
                      [formControl]="subUnit.controls.unavailable"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable"></app-checkbox>
                  </div>

                  <div
                    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                    *ngIf="controlsService.subUnitControls.manufacturer.visible">
                    <app-input
                      [label]="'drr-ccd-devices.manufacturer-of-device-lbl' | translate"
                      [formControl]="subUnit.controls.manufacturer"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable"></app-input>
                  </div>

                  <div
                    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                    *ngIf="controlsService.subUnitControls.designationType.visible">
                    <app-input
                      [label]="'drr-ccd-devices.type-designation-lbl' | translate"
                      [formControl]="subUnit.controls.designationType"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable"></app-input>
                  </div>

                  <div
                    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                    *ngIf="controlsService.subUnitControls.electricalPower.visible">
                    <app-input-number
                      [label]="'drr-ccd-devices.electrical-power-lbl' | translate"
                      [formControl]="subUnit.controls.electricalPower"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable">
                      <app-suffix>
                        <span class="unit-margin">{{ 'drr-ccd-devices.power-units' | translate }}</span>
                      </app-suffix>
                    </app-input-number>
                  </div>

                  <!-- upload-data-sheet -->
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadUnitDataSheet">
                    <app-file-input-form-control
                      [label]="'drr-ccd-devices.upload-data-sheet' | translate"
                      [data]="subUnit.controls.dataSheetRawValue?.value"
                      documentType="drr_ccd_data_sheet"
                      [required]="true"
                      [disabled]="
                        subUnit.value.unavailable || !showUploadUnitDataSheet || (!subUnitSection.isDataEditable && !isUnitEditable)
                      "
                      [clearOn]="fileClearStream(subUnit)"
                      (formInited)="fileFormInited($event, subUnit, 'dataSheet')"></app-file-input-form-control>
                  </div>
                </div>

                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
                  <div
                    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
                    *ngIf="controlsService.subUnitControls.hasAdditionalHeating.visible">
                    <app-radio-button-yes-no
                      [name]="'subUnitHasAdditionalHeating_' + deviceIndex + '_' + i + '_' + ii"
                      [label]="'drr-ccd-devices.additional-heating-lbl' | translate"
                      [formControl]="subUnit.controls.hasAdditionalHeating"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable"
                      [style]="'horizontal'"></app-radio-button-yes-no>
                  </div>

                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showAdditionalHeaterFieldSubUnit(unit, ii)">
                    <app-input-number
                      [label]="'drr-ccd-devices.power-of-additional-heater-lbl' | translate"
                      [formControl]="subUnit.controls.powerOfAdditionalHeater"
                      [forceDisable]="!subUnitSection.isDataEditable && !isUnitEditable">
                      <app-suffix>
                        <span class="unit-margin">{{ 'drr-ccd-devices.power-units' | translate }}</span>
                      </app-suffix>
                    </app-input-number>
                  </div>
                </div>
              </app-review-section>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 nested-item-lev"
              *ngIf="allowAddSubUnit && controlsService.unitControls.subUnits.visible">
              <app-plus-button
                id="add-subunit-btn"
                [label]="getSubUnitLabel(i + 1)"
                (onClick)="controlsService.addSubUnit(unit)"></app-plus-button>
            </div>
          </div>
        </app-review-section>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="ccdType">
      <app-plus-button *ngIf="allowAddUnit" id="add-unit-btn" [label]="unitAddLabel" (onClick)="addUnit()"></app-plus-button>
    </div>
  </div>
</div>
